'use strict';

exports.__esModule = true;
var ROLES = exports.ROLES = {
  LOADING: 'ROLES_LOADING',
  SUCCEEDED: 'ROLES_SUCCEEDED',
  FAILED: 'ROLES_FAILED'
};

var getRoles = exports.getRoles = function getRoles() {
  return {
    type: ROLES.LOADING
  };
};